"use strict";

var _StrictMode;
import '@autoguru/overdrive/dist/reset/globalReset.css';
import '@autoguru/overdrive/dist/reset/globalFonts.css';
import { OverdriveProvider } from '@autoguru/overdrive';
import { LoggingAgentProvider } from '@autoguru/logs';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { SupportedBrowsersBoundary } from '@autoguru/supported-browser-boundary';
import { getMfeMountPoint } from 'gdu/dist/lib/mfe';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { AGSupportedBrowsers } from '~/browsers';
import { App } from './App';
import * as guruConfigs from '../guru.config';
import { jsx as _jsx } from "react/jsx-runtime";
const root = getMfeMountPoint({
  mountDOMId: guruConfigs.mountDOMId,
  projectName: __GDU_APP_NAME__
});
const MFE = () => {
  void createRoot(root).render(_StrictMode || (_StrictMode = /*#__PURE__*/_jsx(StrictMode, {
    children: /*#__PURE__*/_jsx(LoggingAgentProvider, {
      children: /*#__PURE__*/_jsx(OverdriveProvider, {
        children: /*#__PURE__*/_jsx(SupportedBrowsersBoundary, {
          browsers: AGSupportedBrowsers,
          children: /*#__PURE__*/_jsx(Router, {
            children: /*#__PURE__*/_jsx(Routes, {
              children: /*#__PURE__*/_jsx(Route, {
                path: ":tenant/*",
                element: /*#__PURE__*/_jsx(App, {})
              })
            })
          })
        })
      })
    })
  })));
};
export default MFE;